module.exports = __webpack_public_path__ + "img/doctor.be5030ca.webp";